(function () {
  var SECTIE = 'yhd-cart-drawer';
  function wrap() { return document.getElementById('yhd-cart'); }
  function sectieUrl() {
    var u = '/?sections=' + SECTIE;
    if (location.hostname.indexOf('myshopify.com') !== -1) u += '&_fd=0&pb=0';
    return u;
  }

  function open() {
    var w = wrap(); if (!w) return;
    w.classList.add('is-open');
    w.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    startTimer();
  }
  function close() {
    var w = wrap(); if (!w) return;
    w.classList.remove('is-open');
    w.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }
  function isOpen() { var w = wrap(); return w && w.classList.contains('is-open'); }

  function ververs(openNa) {
    return fetch(sectieUrl())
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var html = j[SECTIE];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var nieuw = tmp.querySelector('#yhd-cart');
        var oud = wrap();
        if (nieuw && oud) {
          var was = isOpen();
          oud.replaceWith(nieuw);
          if (was || openNa) { open(); }
        }
        bijwerkTellers();
      })
      .catch(function () {});
  }

  function bijwerkTellers() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('[data-cart-count], .cart-count, .cart-bubble span, cart-icon .cart-bubble').forEach(function (el) {
        if (el.childElementCount === 0) el.textContent = c.item_count;
      });
    }).catch(function () {});
  }

  function zetKorting(code) {
    return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: code }) })
      .then(function (r) { return r.json(); });
  }

  function pasCodeToe(code) {
    code = (code || '').trim();
    var w = wrap(); if (!w) return;
    var msg = w.querySelector('[data-yc-code-msg]');
    var knop = w.querySelector('[data-yc-code-apply]');
    function toon(tekst) { if (msg) { msg.textContent = tekst; msg.hidden = false; } }
    if (!code) { toon('Enter a discount code.'); return; }
    if (knop) { knop.disabled = true; knop.textContent = '...'; }
    if (msg) msg.hidden = true;
    zetKorting(code).then(function (c) {
      var gelukt = (c.discount_codes || []).some(function (d) { return d.applicable && d.code.toLowerCase() === code.toLowerCase(); });
      if (gelukt) { ververs(false); return; }
      zetKorting('').then(function () {
        if (knop) { knop.disabled = false; knop.textContent = 'Apply'; }
        toon('This code cannot be applied to your cart.');
      });
    }).catch(function () {
      if (knop) { knop.disabled = false; knop.textContent = 'Apply'; }
      toon('Something went wrong. Please try again.');
    });
  }

  // timer
  var timerLoop = null;
  function startTimer() {
    var w = wrap(); if (!w) return;
    var el = w.querySelector('[data-yc-timer]'); if (!el) return;
    var min = parseInt(w.dataset.timerMin, 10) || 10;
    var key = 'yhd-cart-deadline';
    var dl;
    try { dl = parseInt(sessionStorage.getItem(key), 10); } catch (e) { dl = 0; }
    var nu = Date.now();
    if (!dl || dl < nu) { dl = nu + min * 60000; try { sessionStorage.setItem(key, String(dl)); } catch (e) {} }
    clearInterval(timerLoop);
    function tik() {
      var el2 = wrap() && wrap().querySelector('[data-yc-timer]');
      if (!el2) { clearInterval(timerLoop); return; }
      var rest = Math.max(0, dl - Date.now());
      if (rest === 0) { dl = Date.now() + min * 60000; try { sessionStorage.setItem(key, String(dl)); } catch (e) {} rest = min * 60000; }
      var m = Math.floor(rest / 60000), sec = Math.floor((rest % 60000) / 1000);
      el2.textContent = m + ':' + (sec < 10 ? '0' : '') + sec;
    }
    tik();
    timerLoop = setInterval(tik, 1000);
  }

  // product-formulieren overnemen (klassieke submits -> AJAX + drawer)
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.action || f.action.indexOf('/cart/add') === -1) return;
    if (f.closest && f.closest('#yhd-cart')) return;
    e.preventDefault();
    e.stopPropagation();
    var fd = new FormData(f);
    fetch('/cart/add.js', { method: 'POST', body: fd })
      .then(function (r) {
        if (r.ok) { ververs(true); }
        else { return r.json().then(function (j) { alert((j && (j.description || j.message)) || 'Could not add to cart.'); }); }
      })
      .catch(function () {});
  }, true);

  // kliks
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    if (t.closest('[data-yc-close]')) { close(); return; }
    var cartLink = t.closest('a[href="/cart"], a[href^="/cart?"], button[aria-label*="cart" i], a[aria-label*="cart" i], cart-icon, .header-actions__cart');
    if (cartLink && !t.closest('#yhd-cart')) { e.preventDefault(); e.stopPropagation(); ververs(true); return; }
    var codeKnop = t.closest('[data-yc-code-apply]');
    if (codeKnop) {
      var codeVeld = wrap().querySelector('[data-yc-code-input]');
      pasCodeToe(codeVeld ? codeVeld.value : '');
      return;
    }
    var codeTip = t.closest('[data-yc-code-use]');
    if (codeTip) { pasCodeToe(codeTip.dataset.ycCodeUse); return; }
    if (t.closest('[data-yc-code-remove]')) {
      zetKorting('').then(function () { ververs(false); });
      return;
    }
    var vopt = t.closest('[data-yc-vopt]');
    if (vopt) {
      var vItem = vopt.closest('.yhd-cart__item');
      var paneel = vItem && vItem.querySelector('.yhd-vopts');
      if (paneel) { paneel.classList.toggle('is-open'); vItem.classList.toggle('vopts-open', paneel.classList.contains('is-open')); }
      return;
    }
    var vswap = t.closest('[data-yc-vswap]');
    if (vswap) {
      if (vswap.classList.contains('is-act') || vswap.disabled) return;
      var upd = {};
      upd[vswap.dataset.old] = 0;
      upd[vswap.dataset.new] = parseInt(vswap.dataset.qty, 10) || 1;
      vswap.disabled = true;
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: upd }) })
        .then(function () { ververs(false); });
      return;
    }
    var item = t.closest('.yhd-cart__item');
    if (item) {
      var line = parseInt(item.dataset.ycLine, 10);
      var qtyEl = item.querySelector('.yhd-cart__qty span');
      var huidige = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
      var nieuw = null;
      if (t.closest('[data-yc-plus]')) nieuw = huidige + 1;
      else if (t.closest('[data-yc-minus]')) nieuw = Math.max(0, huidige - 1);
      else if (t.closest('[data-yc-remove]')) nieuw = 0;
      if (nieuw !== null && !isNaN(line)) {
        fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: line, quantity: nieuw }) })
          .then(function () { ververs(false); });
        return;
      }
    }
    var upadd = t.closest('[data-yc-upadd]');
    if (upadd) {
      var kaart = upadd.closest('.yhd-cart__upcard');
      var sel = kaart && kaart.querySelector('[data-yc-upsel]');
      var vid = sel ? parseInt(sel.value, 10) : parseInt(upadd.dataset.variant, 10);
      upadd.disabled = true;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] }) })
        .then(function () { ververs(false); });
      return;
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
    if (e.key === 'Enter' && e.target && e.target.matches && e.target.matches('[data-yc-code-input]')) {
      e.preventDefault();
      pasCodeToe(e.target.value);
    }
  });

  // open na elke add-to-cart (van welk script dan ook)
  var echteFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = echteFetch.apply(this, arguments);
    if (url.indexOf('/cart/add') !== -1) {
      p.then(function (resp) { if (resp && resp.ok) setTimeout(function () { ververs(true); }, 150); }).catch(function () {});
    }
    return p;
  };
  var EchteXHROpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (methode, url) {
    if (typeof url === 'string' && url.indexOf('/cart/add') !== -1) {
      this.addEventListener('load', function () { setTimeout(function () { ververs(true); }, 150); });
    }
    return EchteXHROpen.apply(this, arguments);
  };
})();
